import Swiper from './swiper-setup';
import $ from 'jquery';

$(_ => {

  new Swiper('#slideshow-home', {
    loop: true,
    pagination: '.swiper-pagination',
    height: 600,
    paginationClickable: true,
    paginationElement: 'button'
  });

});